import { CuentaContableCuentaReadingDtoProps } from "./DTOs/CuentaContableCuentaReadingDto"

export const cuentaContableCuentaAdapter = (
  cuentaContable: CuentaContableCuentaReadingDtoProps
): CuentaContableCuentaReadingDtoProps => ({
  id: cuentaContable.id,
  cuentaContableEmpresaBase: cuentaContable.cuentaContableEmpresaBase,
  cuentaContablePadreNombre: cuentaContable.cuentaContablePadreNombre,
  cuentaContablePadreNumero: cuentaContable.cuentaContablePadreNumero,
  grupoNombre: cuentaContable.grupoNombre,
  grupoNumero: cuentaContable.grupoNumero,
  nombre: cuentaContable.nombre,
  numero: cuentaContable.numero,
  porDefecto: cuentaContable.porDefecto,
  subGrupoNombre: cuentaContable.subGrupoNombre,
  subGrupoNumero: cuentaContable.subGrupoNumero,
})
